<div class="container-fluid complyon-page retention-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell retention-shell mx-auto">
    <section class="mb-3">
      <h1 class="complyon-title retention-title mb-2 text-l">Records & retention</h1>
      <p class="complyon-subtitle retention-subtitle mb-0 text-s">What records must be kept, for how long, who may access them and when they must be archived or destroyed - schedule, legal holds and disposal approvals.</p>
    </section>

    <section class="row g-3 mb-3">
      <div v-for="card in summary_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
        <article class="complyon-card rounded-4 p-3 h-100">
          <div class="complyon-stat-label text-xs">{{ card.label }}</div>
          <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : card.accent === 'green' ? 'text-success' : 'text-dark'">{{ card.value }}</div>
          <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
        </article>
      </div>
    </section>

    <section class="complyon-panel rounded-4 overflow-hidden">
      <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
        <div>
          <div class="complyon-section-title text-s">Records & retention</div>
          <div class="complyon-section-subtitle text-xs">What records must be kept, for how long, who may access them and when they must be archived or destroyed - the retention schedule, legal holds and disposal approvals that sit above the evidence vault.</div>
        </div>
        <button type="button" class="btn config-navbar-primary-action finance-action-btn">
          <i class="bi bi-plus-lg"></i>
          <span>New category</span>
        </button>
      </div>

      <div class="px-3 pb-2 pt-2 d-flex flex-wrap align-items-center justify-content-between gap-2 border-top border-light-subtle">
        <div class="d-flex flex-wrap align-items-center gap-1">
          <button v-for="filter in filters" :key="filter.label" type="button" class="btn doa-tab-btn fw-semibold" :class="{ active: filter.active }">
            <span>{{ filter.label }}</span>
          </button>
        </div>
        <div class="input-group" style="max-width: 170px;">
          <span class="input-group-text bg-white"><i class="bi bi-search text-secondary"></i></span>
          <input type="search" class="form-control" placeholder="Search..." aria-label="Search categories">
        </div>
      </div>

      <div class="table-responsive">
        <table class="table complyon-table align-middle mb-0">
          <thead>
            <tr>
              <th class="ps-3 text-xs">Ref</th>
              <th class="text-xs">Record category</th>
              <th class="text-xs">Retention</th>
              <th class="text-xs">Owner</th>
              <th class="text-xs">Legal hold</th>
              <th class="text-xs">Disposal</th>
              <th class="text-xs">Status</th>
              <th class="pe-3"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="row.ref">
              <td class="ps-3 fw-semibold text-success">{{ row.ref }}</td>
              <td class="fw-semibold">{{ row.category }}</td>
              <td>{{ row.retention }}</td>
              <td>{{ row.owner }}</td>
              <td>{{ row.legal_hold }}</td>
              <td>{{ row.disposal }}</td>
              <td><span class="badge complyon-badge text-xs" :class="row.status.class">{{ row.status.label }}</span></td>
              <td class="pe-3 text-end"><i class="bi bi-chevron-right finance-arrow"></i></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</div>
